var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":""}},[(_vm.convertEmployees.length)?_c('v-data-table',{staticClass:"call-center-employee-table",attrs:{"headers":_vm.headers,"items":_vm.convertEmployees,"items-per-page":1000,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.totalCall",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatPrice(item.totalCall))+" ")]}},{key:"item.totalDuration",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s((+item.totalDuration / 60).toFixed(2))+" ")]}},{key:"item.numberOfOrders",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatPrice(item.numberOfOrders))+" ")]}},{key:"item.totalPrice",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatPrice(item.totalPrice))+" ")]}}],null,false,3016075477)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }